import script from "./CongraduationModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CongraduationModal.vue?vue&type=script&setup=true&lang=js"

import "./CongraduationModal.vue?vue&type=style&index=0&id=3e51274f&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e51274f"]])

export default __exports__